module.exports = __webpack_public_path__ + "media/theme/blog__border-3-43680e8a.png";